export default {
	home: () => { import('./home'); },
	single_superunie_product: () => { import('./single-superunie_product')},
	search: () => { import('./search')},
	tax_superunie_product_cat: () => { import('./tax-superunie_product_cat')},
}